module.exports = __webpack_public_path__ + "img/foto18plus.0cbc8853.jpg";